import Button from "Components/Button";
import FormTextArea from "Components/FormTextArea";
import React, { Component } from "react";
import { Field, Form } from "react-final-form";
import styled from "styled-components";

const validate = values => {
  const errors = {};
  if (!values.message) {
    errors.message = "Required";
  }
  return errors;
};

const ButtonContainer = styled.div`
  width: 30%;
  float: right;
`;

class SendMessageForm extends Component {
  render() {
    const { handleSubmit, fetching, success } = this.props;
    return (
      <Form
        onSubmit={handleSubmit}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Field
              name={"message"}
              render={props => {
                return (
                  <FormTextArea
                    {...props}
                    placeholder={"Write your message here"}
                  />
                );
              }}
            />
            <ButtonContainer>
              <Button type={"submit"}>
                {fetching ? "Sending..." : success ? "Sent!" : "Send"}
              </Button>
            </ButtonContainer>
          </form>
        )}
      />
    );
  }
}

export default SendMessageForm;
